import { cloneDeep } from 'lodash';
import AutoCalculatedSurveyMap from '../shared/AutoCalculatedSurveyMap';
import SurveyChartUtils from '../shared/SurveyChartUtils';

const SurveyResultsMapper = {
  toSurveyResultsData: questions => {
    const cloned = cloneDeep(questions);

    return cloned.map(question => {
      const autoCalculatedField = AutoCalculatedSurveyMap[question.Id];

      if (autoCalculatedField && !question.SurveyResults.some(r => r.IsAutoCalculated)) {
        const years = SurveyChartUtils.getSurveyYears(question.SurveyResults);
        question.SurveyResults.push({
          ...autoCalculatedField.createResult(years, question.SurveyResults),
          QuestionId: question.Id
        });
      }

      return question;
    });
  }
};

export default SurveyResultsMapper;
